import { render, staticRenderFns } from "./MessageAllList.vue?vue&type=template&id=5beaaf3e&scoped=true&"
import script from "./MessageAllList.vue?vue&type=script&lang=js&"
export * from "./MessageAllList.vue?vue&type=script&lang=js&"
import style0 from "./MessageAllList.vue?vue&type=style&index=0&id=5beaaf3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beaaf3e",
  null
  
)

export default component.exports